import { useCallback } from 'react';
import { Content } from '../types/content';
import { shareContent } from '../utils/share';
import { useToast } from './useToast';

export function useShare() {
  const { show: showToast } = useToast();

  const handleShare = useCallback(async (content: Content) => {
    const url = `${window.location.origin}/${content.type}/${content.id}`;
    const title = 'title' in content ? content.title : 'Share this content';
    const text = 'description' in content 
      ? content.description 
      : ('content' in content ? content.content : '');
    
    try {
      await shareContent(title, text, url);
      showToast('Link copied to clipboard!', 'success');
    } catch (error) {
      showToast('Failed to share content', 'error');
      console.error('Share error:', error);
    }
  }, [showToast]);

  return handleShare;
}